import { Section } from './../../models/module-structure';
import { LayoutService } from 'src/app/layout/layout.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterFieldValue } from 'src/app/apps/subscription/classes';

@Component({
  selector: 'app-table-section-container',
  templateUrl: './table-section-container.component.html',
  styleUrls: ['./table-section-container.component.less'],
})
export class TableSectionContainerComponent implements OnInit {
  sectionIdVal = 0;
  @Input() thereIsFilters = false;
  @Input() set sectionId(val: number) {
    if (this.sectionIdVal !== val) {
      this.sectionIdVal = val;
      this.dataTable = {
        name: '',
        dataset: [],
      };

      this.loadData();
    }

    this.sectionIdVal = val;
  }

  get sectionId(): number {
    return this.sectionIdVal;
  }

  @Input() tableName = '';
  @Input() isTableLoading = false;

  filterFieldsValue: FilterFieldValue[];
  @Input() set filterFields(value: FilterFieldValue[]) {
    console.log(value);
    this.filterFieldsValue = value;

    if (this.section !== undefined) {
      this.getData();
    } else {
      this.loadData(true);
    }
  }

  get filterFields() {
    return this.filterFieldsValue;
  }

  section: Section;
  isLoading = true;

  @Input() dataTable: { name: string; dataset: any[] };
  @Output() dataTableChange = new EventEmitter<{
    name: string;
    dataset: any[];
  }>();

  constructor(private layoutService: LayoutService) {}

  ngOnInit(): void {
    this.dataTable = {
      name: '',
      dataset: [],
    };

    this.loadData();
  }

  loadData(forceGetDate = false) {
    this.layoutService.getSection(this.sectionId).subscribe((d: Section) => {
      this.section = d;
      if (!this.thereIsFilters || forceGetDate) {
        this.getData();
      }
    });
  }

  getData(): void {
    this.isLoading = true;
    this.dataTable = {
      name: '',
      dataset: [],
    };

    //console.log('this.filterFields', this.filterFields);
    this.dataTable.name = this.tableName;
    const filterData: FilterFieldValue[] = [];
    if (this.filterFields != null && this.filterFields !== undefined) {
      for (const filterField of this.filterFields) {
        if (filterField.Value !== undefined && filterField.Value[0] !== '' && filterField.Value[0] !== null && filterField.Value[0] !== 'null') {
          filterData.push({
            FieldName: filterField.FieldName,
            Value: filterField.Value,
          });
        } else {
          filterData.push({ FieldName: filterField.FieldName, Value: [''] });
        }
      }
    }

    this.layoutService
      .getDataFromQuery(this.section.SQLStatementId, filterData)
      .subscribe((d: any) => {
        this.dataTable.dataset = d.table.rowsArray;
        this.dataTableChange.emit(this.dataTable);
        this.isLoading = false;
      });
  }
}
